import { Alert } from 'antd';

import styled from '@emotion/styled';

export const Banner = styled(Alert)`
  margin-bottom: 16px;
`;

export const List = styled.ul`
  margin: 4px 0 0;
  padding-left: 20px;
`;
